import {
  IAllServiceLineSynonymsResponse,
  IServiceLineSynonymCreateRequest,
  IServiceLineSynonymResponse,
  IServiceLineSynonymUpdateRequest,
} from "types/ServiceLineSynonym/ServiceLineSynonym";

import { api } from ".";

/**
 * CLE-2341 — Service-line synonym dictionary CRUD. Super-admin gated server-side.
 * Backend resolver lives in services/clear-api/src/domains/service_line_synonyms;
 * the runtime `resolveServiceLine` helper is NOT exposed via HTTP (only invoked
 * in-process by the rate expander).
 */
const serviceLineSynonymsQueries = api.injectEndpoints({
  endpoints: (builder) => ({
    getAllServiceLineSynonyms: builder.query<
      IAllServiceLineSynonymsResponse,
      { accountId?: string; payerId?: number } | null | void
    >({
      query: (params) => {
        const search = new URLSearchParams();
        if (params?.accountId) search.set("accountId", params.accountId);
        if (params?.payerId != null)
          search.set("payerId", String(params.payerId));
        const qs = search.toString();
        return `service-line-synonyms/all${qs ? `?${qs}` : ""}`;
      },
      providesTags: ["ServiceLineSynonyms"],
    }),
    getServiceLineSynonym: builder.query<IServiceLineSynonymResponse, string>({
      query: (id) => `service-line-synonyms/${id}`,
      providesTags: (_r, _e, id) => [{ type: "ServiceLineSynonyms", id }],
    }),
    createServiceLineSynonym: builder.mutation<
      IServiceLineSynonymResponse,
      IServiceLineSynonymCreateRequest
    >({
      query: (body) => ({
        url: "service-line-synonyms",
        method: "POST",
        body,
      }),
      invalidatesTags: ["ServiceLineSynonyms"],
    }),
    updateServiceLineSynonym: builder.mutation<
      IServiceLineSynonymResponse,
      { id: string; body: IServiceLineSynonymUpdateRequest }
    >({
      query: ({ id, body }) => ({
        url: `service-line-synonyms/${id}`,
        method: "PUT",
        body,
      }),
      invalidatesTags: ["ServiceLineSynonyms"],
    }),
    deleteServiceLineSynonym: builder.mutation<void, string>({
      query: (id) => ({
        url: `service-line-synonyms/${id}`,
        method: "DELETE",
      }),
      invalidatesTags: ["ServiceLineSynonyms"],
    }),
  }),
});

export const {
  useGetAllServiceLineSynonymsQuery,
  useGetServiceLineSynonymQuery,
  useCreateServiceLineSynonymMutation,
  useUpdateServiceLineSynonymMutation,
  useDeleteServiceLineSynonymMutation,
} = serviceLineSynonymsQueries;
